import { render, staticRenderFns } from "./annotation-list.vue?vue&type=template&id=2ffece1c&"
import script from "./annotation-list.vue?vue&type=script&lang=js&"
export * from "./annotation-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports